//packages
import React from "react";
import { Carousel, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLongArrowAltRight,
  faMapMarkerAlt,
  faCaretRight,
  faChevronLeft,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
//global components
import MainMenu from "../../_components/MainMenu";
import MainFooter from "../../_components/MainFooter";
import PreLoader from "../../_components/PreLoader";
//services
import { menuService } from "../../_services/menu.service";
import { postService } from "../../_services/post.service";
import { cartService } from "../../_services/cart.service";
import { formatPrice } from "../../_helpers";

import Swal from "sweetalert2/dist/sweetalert2.js";

import quote from '../../_img/quote.svg';

//styles
import "./Welcome.sass";

class Welcome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: {
        details: {},
      },
      menu: {},
      topbarMenu: {},
      // testimonials: {},
      // keyboardists: {},
      // producers: {},
      // guitarPlayers: {},
      // products: {},
      // news: {},
      // artist: {},
      // branches: {},
      newArrival: true,
      prodNewArrival: {},
      prodSpecial: [],
      viewProducts: [],
      cart: [],
      slides: [],
      data: null,
      imageUrls: {},
      isLoading: true,
      products: [],
      error: null,
      news: [],
      testimonials:[],
      artists:[],
      branches:[],
    };

    this.productRoute = this.productRoute.bind(this);
  }

  productRoute(slug) {
    this.props.history.push(`product/${slug}`);
  }

  handleProductDetail(slug) {
    this.context.router.push({
      pathname: "/products/",
      state: { product: { slug: slug } },
    });
  }

  addToCart = (productId) => {

    // Fetch nonce first
    cartService.getAllCart()
    .then(nonce => {
        console.log('Fetched nonce:', nonce); // Ensure nonce is fetched
        // Add the product to the cart using the fetched nonce
        return cartService.addToCart(productId, 1);
    })
    .then(data => {
        console.log('Product added to cart:', data);
        this.setState({cart: data})
        Swal.fire({
            position: "top-end",
            icon: "success",
            title: data.name + " has been added to your shopping cart.",
            showConfirmButton: false,
            timer: 1500,
          });
    })
    .catch(error => {
        console.error('Failed to add product to cart:', error);
        Swal.fire({
            position: "top-end",
            icon: "error",
            title: "An error occured when retrieving your cart.",
            showConfirmButton: false,
            timer: 3000,
          });
    });
};

componentDidMount() {
    // Prevent automatic scroll restoration
    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual'; // Explicitly using window.history
    }

    // Lock scroll before loading starts
    document.body.style.overflow = "hidden";

    // Scroll to the top immediately when the component loads
    window.scrollTo(0, 0);

    Promise.allSettled([
      menuService.getMenuByName('default').then(menu => this.setState({ menu })),
      menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
      postService.getSlides().then(slideData => this.setState({ slides: slideData })),
      postService.getCards().then(cardsData => this.setState({ data: cardsData })),
      postService.getProducts('new').then(productsData => this.setState({ products: productsData })),
      postService.getProducts('sale').then(specialData => this.setState({ prodSpecial: specialData })),
      postService.getNews('news', 'featured').then(newsData => this.setState({ news: newsData.items })),
      postService.getNews('testimonial').then(newsData => this.setState({ testimonials: newsData.items })),
      postService.getNews('artists').then(artistData => this.setState({ artists: artistData.items })),
      postService.getBranches('branch','branches').then(branchesData => this.setState({ branches: branchesData.items, viewProducts: branchesData.viewProducts })),
    ]).then(() => {
        // Once all data has loaded, scroll to the top again
        window.scrollTo(0, 0);

        // Unlock the scroll after loading is complete
        document.body.style.overflow = "auto";

        // Now check URL for email verification and show Swal if necessary
        const query = new URLSearchParams(window.location.search);
        const emailVerified = query.get('email_verified');

        if (emailVerified === 'true') {
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: 'Success!',
                text: 'Your email has been successfully verified.',
                showConfirmButton: true,
            });
        }

        // Handle user state loading
        const user = JSON.parse(localStorage.getItem("user"));
        if (user && Date.now() < user.expiresAt) {
            this.setState({
                user: user,
            });
        } else {
            this.setState({
                user: {
                    details: {},
                },
            });
        }

        // Mark loading as false after everything is complete
        this.setState({ loading: false });
    });
}


  render() {
    const {
      loading,
      user,
      cart,
      menu,
      topbarMenu,
      testimonials,
      news,
      artists,
      branches,
      prodSpecial,
      newArrival,
      viewProducts
    } = this.state;

    const { slides, data } = this.state;
    const {  products} = this.state;

    return (
      <div className="home-container">
        <PreLoader loading={loading} />
        <MainMenu user={user} menu={menu} cart={cart} ref={this.cartRef} topbarMenu={topbarMenu} />
        {/* carousel */}
        <div id="HeaderCarousel" className="carousel slide carousel-fade main-carousel" data-ride="carousel">
                <div className="carousel-inner">
                    {slides.map((slide, index) => (
                        <div key={index} className={index === 0 ? "carousel-item active" : "carousel-item"}>
                            <img src={slide.imageUrl} className="d-block w-100" alt="..." />
                            <div className="carousel-caption">
                                <div className="row">
                                    <div className="col-lg-5 ml-auto text-left">
                                        {/* Add other slide content here */}
                                        <a href={`${slide.productUrl}`} className="btn btn-link float-right">
                                            view product <FontAwesomeIcon icon={faLongArrowAltRight} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <a className="carousel-control-prev" href="#HeaderCarousel" role="button" data-slide="prev">
                    <FontAwesomeIcon icon={faChevronLeft} size="2x" />
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#HeaderCarousel" role="button" data-slide="next">
                    <FontAwesomeIcon icon={faChevronRight} size="2x" />
                    <span className="sr-only">Next</span>
                </a>
                <ol className="carousel-indicators">
                    {slides.map((slide, index) => (
                        <li key={index} data-target="#HeaderCarousel" data-slide-to={index}></li>
                    ))}
                </ol>
        </div>
        
        {/* market cards */}
        <section className="categories py-5 my-5">
            <div className="container-fluid">
                <div className="card-deck">
                {data &&
                    data
                    .slice() // Create a shallow copy of the array to avoid mutating the original data
                    .sort((a, b) => a.acf.order - b.acf.order).map(item => (
                    <div className="card cat-card-single for-k mb-sm-5 mb-lg-0" key={item.id} style={{ backgroundImage: `url(${item.imageUrl})` }} >
                        <div className="card-body"  style={{ backgroundImage: `url(${item.imageCardUrl})` }}>
                        <h2 className="card-title" style={{color:item.acf.maincolor}}>
                            <span className="d-block">{item.acf.subtitle}</span>{" "}
                            {item.acf.title || "Keyboardists"}
                        </h2>
                        <p className="card-text">{item.acf.content}</p>
                        <div className="cat-tags -ct01">
                            {item.categoryDetails && Array.isArray(item.categoryDetails) && item.categoryDetails.map((category, index) => (
                                <span key={index}>
                                    <a href={category.link} className="btn btn-sm btn-cat mt-1" style={{backgroundColor:item.acf.maincolor}}>
                                        {category.name} <FontAwesomeIcon icon={faCaretRight} />
                                    </a>
                                    &nbsp;
                                </span>
                            ))}
                        </div>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </section>
    

        {/* product cards */}
        
          <section className="single-product py-5 my-5">
            <div className="container">
              <div className="row">
                <div className="col-sm-6">
                  <h2>{newArrival ? "New Arrivals" : "Specials"}</h2>
                </div>
                <div className="col-sm-6">
                  <ul className="nav justify-content-end" id="myTab">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="new-arrivals-tab"
                        data-toggle="tab"
                        href="#new-arrivals"
                        role="tab"
                        aria-controls="new arrivals"
                        aria-selected="true"
                        onClick={() => this.setState({ newArrival: true })}
                      >
                        New Arrivals
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="specials-tab"
                        data-toggle="tab"
                        href="#specials"
                        role="tab"
                        aria-controls="specials"
                        aria-selected="false"
                        onClick={() => this.setState({ newArrival: false })}
                      >
                        Specials
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="tab-content">
                <div
                  className="tab-pane fade show active"
                  id="new-arrivals"
                  role="tabpanel"
                  aria-labelledby="new-arrivals-tab"
                >
                  <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-6">
                    {products &&
                      products.map((prod, index) => (
                        <div key={index} className="col mb-sm-3">
                          <div className="card product-card-single mb-sm-3 h-100">
                            {prod.images && (
                              <img
                                src={prod.images[0]?.src}
                                className="card-img-top"
                                alt="..."
                                onClick={() => this.productRoute(prod.slug)}
                              />
                            )}
                            <div
                              className="card-body"
                              onClick={() => this.productRoute(prod.slug)}
                            >
                              <h5
                                className="card-title"
                                onClick={() => this.productRoute(prod.slug)}
                              >
                                {prod.name}
                              </h5>
                            </div>
                            <div className="card-footer">
                               {prod.on_sale == true &&
                                <small><s className="text-muted">{formatPrice(prod.regular_price, { minimumFractionDigits: 0 })}</s></small>
                              }
                              <p className="card-text price mb-1">
                                <strong>{ prod.on_sale !== false ? formatPrice(prod.price, { minimumFractionDigits: 0 }) : formatPrice(prod.regular_price, { minimumFractionDigits: 0 }) }</strong>
                              </p>
                              
                              <button
                                disabled={prod.stock_quantity <= 0}
                                className="btn btn-primary"
                                onClick={() => {
                                  if (prod.stock_quantity <= 0) return;

                                  this.addToCart(
                                    prod.id,
                                  )
                                
                                }}
                              >
                                Add to Cart
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  {products.length < 1 && (
                    <div className="no-item row">
                      <div className="col-sm-12">
                        No <strong>New Arrival</strong> Products available
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="tab-pane fade show"
                  id="specials"
                  role="tabpanel"
                  aria-labelledby="new-arrivals-tab"
                >
                  <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-6">
                    {prodSpecial && Array.isArray(prodSpecial) &&
                      prodSpecial.map((prod, index) => (
                        <div key={index} className="col mb-sm-3">
                          <div className="card product-card-single mb-sm-3 h-100">
                            {prod.images && (
                              <img
                                src={prod.images[0]?.src}
                                className="card-img-top"
                                alt="..."
                                onClick={() => this.productRoute(prod.slug)}
                              />
                            )}
                            <div className="card-body">
                              <h5
                                className="card-title"
                                onClick={() => this.productRoute(prod.slug)}
                              >
                                {prod.name}
                              </h5>
                            </div>
                            <div className="card-footer">
                              {prod.on_sale == true &&
                                <small><s className="text-muted">{formatPrice(prod.regular_price, { minimumFractionDigits: 0 })}</s></small>
                              }
                              <p className="card-text price mb-1">
                                <strong>{ prod.on_sale !== false ? formatPrice(prod.price, { minimumFractionDigits: 0 }) : formatPrice(prod.regular_price, { minimumFractionDigits: 0 }) }</strong>
                              </p>
                              <button
                                disabled={prod.price <= 0 || prod.stock_status.toLowerCase() === "out of stock"}
                                className="btn btn-primary"
                                onClick={() => {
                                  if (prod.stock_quantity <= 0 || prod.stock_status.toLowerCase() === "out of stock") return;

                                  this.addToCart(
                                    prod.id
                                  )
                                
                                }}
                              >
                                Add to Cart
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </section>


        {/* latest news */}       
        {news && news.length > 0 && (
            <section className="latest-news py-5">
                <div className="container">
                {news.map((item, index) => (
                    <div key={index} className="jumbotron mb-4"
                    style={{
                        background: `linear-gradient(270deg, #00072d 0%, #00072d 40%, rgba(0, 7, 45, 0) 70%), url(${item.imageUrl}) center left no-repeat`,
                    }}
                    >
                    <div className="row">
                        <div className="col-sm-5 ml-auto">
                        <h2 className="text-white">{item.title.rendered}</h2>
                        <p
                            className="artist-content"
                            dangerouslySetInnerHTML={{
                            __html:
                                item.content.rendered
                                .replace(/<img[^>]*>/g, "")
                                .replace(/<p[^>]*>/g, "<p>")
                                .substr(0, 500) + "...",
                            }}
                        />
                        <a className="btn btn-link" href={item.link} >
                            Read Articles <FontAwesomeIcon icon={faLongArrowAltRight} />
                        </a>
                        </div>
                    </div>
                    </div>
                ))}
                </div>
            </section>
            )}

        
        {/* testimonial cards */}
        {testimonials && Array.isArray(testimonials) && (
            <section className="testimonials mb-5">
                <div className="container">
                    <div className="card-deck">
                        {testimonials.slice(0, 3).map((testimonial, index) => (
                            <div key={index} className="card testimonial-card-single">
                                <div className="card-body">
                                    <img src={quote} alt="" />
                                    <p
                                        className="card-text font-italic pt-3"
                                        dangerouslySetInnerHTML={{ __html: testimonial.content.rendered }}
                                    />

                                    <h5>{testimonial.title.rendered}</h5>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        )}
        <hr />

        {/* artists section */}
        
        {artists && Array.isArray(artists) && (
          <section className="artist pb-5 my-5">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h2 className="pb-5">Artists</h2>
                  <Carousel
                    id="ArtistCarousel"
                    className="slide carousel-fade artist-carousel"
                    data-ride="carousel"
                    prevIcon={false}
                    nextIcon={false}
                    indicators={true}
                  >
                    {artists &&
                      artists.map((artist, index) => (
                        <Carousel.Item className={index === 0 ? "active" : ""} key={index}>
                          <Image className="d-block artist-image" src={artist.imageUrl} alt="..." />
                          <Carousel.Caption className="text-left p-md-5">
                            <h3>{artist.title.rendered}</h3>
                            <p
                              className="artist-content"
                              dangerouslySetInnerHTML={{
                                __html: artist.content.rendered
                                  .replace(/<img[^>]*>/g, "")
                                  .substr(0, 500)
                                  .concat(
                                    artist.content.rendered.replace(/<img[^>]*>/g, "").length > 500
                                      ? "..."
                                      : ""
                                  ),
                              }}
                            />
                            <a
                              href={artist.link}
                              className="btn btn-link float-right"
                            >
                              READ MORE <FontAwesomeIcon icon={faLongArrowAltRight} />
                            </a>
                          </Carousel.Caption>
                        </Carousel.Item>
                      ))}
                  </Carousel>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* store branches */}
        
        {branches &&
			Array.isArray(branches) &&
			(
			<section className="top-store py-5">
				<div className="container">
				<div className="row">
					<div className="col-12">
					{viewProducts && Array.isArray(viewProducts) && viewProducts.length > 0 && (
						viewProducts.map((product) => (
						<div key={product.id}>
							<h2>{product.title.rendered}</h2>
							<div dangerouslySetInnerHTML={{ __html: product.content.rendered }}></div>
						</div>
						))
					)}
					<div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-5">
						{branches.map((store, index) => (
						<div className="col mb-3 mb-lg-0" key={index}>
							<div className="card store-card-single">
							<img
								src={store.imageSrc ? store.imageSrc : "https://via.placeholder.com/255x140"}
								className="card-img-top"
								onError={(e) => {
								e.target.src = "https://via.placeholder.com/255x140"
								}}
								alt="..."
								style={{
								maxHeight: "140px",
								width: "auto",
								objectFit: "contain"
								}}
							/>
							<div className="card-body p-0">
								<h4 className="card-title pt-2" dangerouslySetInnerHTML={{ __html: store.title.rendered }} />
								<p className="card-text" >
								{store.acf.address1 || ''} {store.acf.address2 || ''},
								{store.acf.city || ''}
								<br /> <br />
								<span>Phone: </span>
								<span key={index}><a href={'callto://' + store.acf.phone}>{store.acf.phone}</a>{store.acf.phone.split(',').length - 1 === index ? '' : ','}&nbsp;</span>
								{
									store.acf.fax &&
									<span><br />Fax: <a href={'callto://' + store.acf.fax}>{store.acf.fax}</a></span>
								}
								{store.acf.email &&
									<span><br />Email: <a href={'mailto://' + store.acf.email}>{store.acf.email}</a></span>
								}
								</p>
							</div>
							<div className="card-footer p-0">
								<p className="card-text">
								{store.acf.mapurl &&
									<a href={store.acf.mapurl}>
									<FontAwesomeIcon icon={faMapMarkerAlt} /> View Map
									</a>
								}
								</p>
							</div>
							</div>
						</div>
						))}
					</div>
					</div>
				</div>
				</div>
			</section>
			)}
        <MainFooter menu={menu} branches={branches} />
      </div>
    );
  }
}

export { Welcome };
